import { render, staticRenderFns } from "./StubPreloaderCart.vue?vue&type=template&id=1b8fb86b&"
import script from "./StubPreloaderCart.vue?vue&type=script&lang=js&"
export * from "./StubPreloaderCart.vue?vue&type=script&lang=js&"
import style0 from "./StubPreloaderCart.vue?vue&type=style&index=0&id=1b8fb86b&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports